import { FindParams } from './find-params';

export interface FindScheduleParams extends FindParams {
  default?: boolean;
  selected?: string;
}
